import { t } from '@/lib/helpers'
import {
  forwardRef,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react'
import { MdCalendarToday } from 'react-icons/md'

type InputCalendarProps = {
  value?: string
  onClick?: () => void
  size: 'sm' | 'md'
}

export const InputCalendar = forwardRef((props: InputCalendarProps, ref) => {
  const { value, onClick, size } = props
  return (
    <InputGroup
      size={size}
      sx={size === 'sm' ? { flex: '1 0 240px', height: '32px' } : {}}
    >
      <Input
        placeholder={t(
          'views.features.packages.page_views.filter.date_range_place_holder',
        )}
        value={value}
        onClick={onClick}
        onChange={() => {}}
        ref={ref}
        height={size === 'md' ? '48px' : '32px'}
        width="250px"
        _placeholder={{ color: 'gray.600' }}
      />
      <InputRightElement paddingTop={size === 'md' ? '6px' : '0px'}>
        <Icon as={MdCalendarToday} color="gray.400" />
      </InputRightElement>
    </InputGroup>
  )
})
